import { render, staticRenderFns } from "./RecruitDoctor.vue?vue&type=template&id=9b0f2f8a&scoped=true&"
import script from "./RecruitDoctor.vue?vue&type=script&lang=js&"
export * from "./RecruitDoctor.vue?vue&type=script&lang=js&"
import style0 from "./RecruitDoctor.vue?vue&type=style&index=0&id=9b0f2f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0f2f8a",
  null
  
)

export default component.exports